import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class SubjectInvoiceApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'subject-invoice'
  }

  /**
   * 导出
   * @returns
   */
  public excel(params) {
    return this.download(params, "excel")
  }


}
